import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import {
    GIFT_CARD_BANNER_MAG_PARTIAL_ITEM_ADDED,
    GIFT_CARD_BANNER_MAG_ERROR,
    GIFT_CARD_BANNER_MAG_ITEM_ADDED,
} from 'yoda-checkout-components/lib/common/Constants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { hideGiftCardBannerMessage } from '../../actions/GiftCardBannerAction';

export function GiftCardBannerMessage(props) {
    const { isSuccess, freeShipping } = props;
    const messageType = isSuccess ? 'success' : 'error';
    const onCloseIcon = () => {
        const {
            actions: { hideGiftCardBannerMessage: hideGiftCardBannerMessageAction },
        } = props;
        hideGiftCardBannerMessageAction();
    };
    let message = '';
    if (isSuccess) {
        message = freeShipping
            ? GIFT_CARD_BANNER_MAG_ITEM_ADDED
            : GIFT_CARD_BANNER_MAG_PARTIAL_ITEM_ADDED;
    } else {
        message = GIFT_CARD_BANNER_MAG_ERROR;
    }
    return (
        <div className={dt(['mt-4', 'smMd:my-0'])}>
            <MessageBox
                type={messageType}
                level="section"
                title={message}
                hasClose
                automationId="at-gcb-add-to-cart-msg"
                onClose={onCloseIcon}
            />
        </div>
    );
}

GiftCardBannerMessage.defaultProps = {
    isSuccess: false,
    freeShipping: false,
    actions: {},
};

GiftCardBannerMessage.propTypes = {
    isSuccess: PropTypes.bool,
    freeShipping: PropTypes.bool,
    actions: PropTypes.objectOf(PropTypes.func),
};

const mapStateToProps = (state) => ({
    isSuccess: get(state, 'giftCardBannerData.isSuccess', false),
    freeShipping: get(state, 'giftCardBannerData.freeShipping', false),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            hideGiftCardBannerMessage,
        },
        dispatch
    ),
});
export default connect(mapStateToProps, mapDispatchToProps)(GiftCardBannerMessage);
